export default "/images/3ca323217ac8a3d6d22e602b30d28f00.avif";